import { useUser } from "entities/User";
import { userStore } from "entities/User/store/userStore";
import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { useAuthPersistedStore, useAuthStore } from "shared";
import { FullPageLoader, NetworkError } from "shared/ui";
import { authService } from "../api/service/authService";
import Layout from "app/Layout/Layout";
import AuthApiError from "../ui/AuthApiError/AuthApiError";

const RequireAuthentication = () => {
  const [networkError, setNetworkError] = useState(false);
  let [searchParams, setSearchParams] = useSearchParams();
  const state = searchParams.get("state");
  const code = searchParams.get("code");

  const isLoggedIn = useAuthPersistedStore((state) => state.isLoggedIn);
  const setIsLoggedIn = useAuthPersistedStore((state) => state.setIsLoggedIn);

  const authError = useAuthStore((state) => state.authError);
  const setAuthError = useAuthStore((state) => state.setAuthError);

  const setUser = userStore((state) => state.setUser);
  const {
    data: user,
    error,
    isLoading,
  } = useUser({
    triggerRequest: isLoggedIn,
  });

  useEffect(() => {
    if (user) {
      setUser(user);
    }
  }, [user]);

  useEffect(() => {
    return () => setNetworkError(false);
  }, []);

  useEffect(() => {
    if (error?.code === "ERR_NETWORK") setNetworkError(true);
  }, [error]);

  useEffect(() => {
    if (!isLoggedIn && !authError) {
      if (state && code) {
        authService
          .loginConfirm({ state, code })
          .then(() => {
            setIsLoggedIn(true);
            setSearchParams({});
          })
          .catch((error) => {
            if (error?.code === "ERR_NETWORK") setNetworkError(true);
            else setAuthError(true);
            setSearchParams({});
          });
      } else {
        authService.login().catch((error) => {
          if (error?.code === "ERR_NETWORK") setNetworkError(true);
          else setAuthError(true);
        });
      }
    }
  }, [isLoggedIn, authError, state, code]);

  if (networkError) return <NetworkError />;

  if (authError) return <AuthApiError />;

  if (!isLoggedIn || !user || isLoading) return <FullPageLoader />;

  return <Layout />;
};

export default RequireAuthentication;
